import { render, staticRenderFns } from "./TblLotDetail.vue?vue&type=template&id=548fc048&scoped=true&"
import script from "./TblLotDetail.vue?vue&type=script&lang=js&"
export * from "./TblLotDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblLotDetail.vue?vue&type=style&index=0&id=548fc048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548fc048",
  null
  
)

export default component.exports